// const moment = require("moment");
const SubpagesData = [
  {
    title: "Software Developer",
    time: "Jan 2021 - April 2021",
    company: "360 Education Labs Inc. (Yuja.com)",
    type: ["Co-op"],
    location: "Toronto, ON",
    beginningDate: new Date("January 1, 2021"),
    endDate: new Date("April 31, 2021"),
    text: [
      "Conducted 1000+ test cases in Testrail for better software performance across different devices.",
      "Solved 30+ bug reports & feature tickets using Java and Typescript and tested it for optimal results.",
      "Transition from manual to automated testing by creating test cases using Java, Selenium and Git.",
      "Used Postman to test APIs and created automated test cases using Typescript saving manual time.",
    ],
  },
  {
    title: "Undergraduate TA",
    time: "Sept 2021 - Dec 2021",
    company: "University of Waterloo",
    type: "Co-op",
    location: "Waterloo, ON",
    beginningDate: new Date("September 1, 2021"),
    endDate: new Date("December 31, 2021"),
    text: [
      "Solved Linear Algebra, Physics & Calculus doubts of 100s of students helping them with academics.",
      "Conducted 30+ help sessions for Linear Algebra, engaging & teaching students the core concepts.",
      "Analyzed progress of students and mapped out a plan helping them score higher grades.",
      "Critiqued 35+ resumes and helped students through their co-op process using leadership skills.",
    ],
  },

  {
    title: "Web Developer and Design",
    time: "Jan 2022 - Apr 2022",
    company: "Ministry of Government and Consumer Services",
    type: "Co-op",
    location: "Toronto, ON",
    beginningDate: new Date("January 1, 2022"),
    endDate: new Date("April 30, 2022"),
    text: [
      "Developed new user-centric website in WordPress, integrating Bootstrap for widgets & components.",
      "Analyzed views per page & page interactions using Google Analytics & removed unnecessary pages.",
      "Developed Excel program to summarize & graph the events info saving manual time by 40%.",
      "Used agile framework to create versions of the website by gathering statistics about existing phases.",
    ],
  },
  {
    title: "Data Scientist",
    time: "Sept 2022 - Dec 2022",
    company: "Environment and Climate Change Canada",
    type: "Co-op",
    location: "Ottawa, ON",
    beginningDate: new Date("September 1, 2022"),
    endDate: new Date("December 31, 2022"),
    text: ["I'm currently working on this section. Come back later."],
  },
  {
    title: "Data Scientist",
    time: "Jan 2023 - Present",
    company: "Environment and Climate Change Canada",
    type: ["Current", "Part-time"],
    location: "Ottawa, ON",
    beginningDate: new Date("January 1, 2023"),
    endDate: new Date("April 31, 2023"),
    text: [
      "Developed OCR software from scratch using OpenCV in Python to extract data from foreign permits. ",
      "Implemented custom preprocessing pipelines to handle variations in text - font, size, and orientation. ",
      "Optimized disk space by creating file compression software in Python saving 40% disk space.",
    ],
  },
  {
    title: "Computer Research Assistant",
    time: "May 2022 - Present",
    company: "University of Waterloo",
    type: ["Current", "Part-time"],
    location: "Waterloo, ON",
    beginningDate: new Date("May 1, 2022"),
    endDate: new Date("April 31, 2023"),
    text: ["I'm currently working on this section. Come back later."],
  },
  {
    title: "Data Science Researcher",
    time: "Jan 2024 - Present",
    company: "University of Waterloo",
    type: ["Current"],
    location: "Waterloo, ON",
    beginningDate: new Date("Jan 1, 2024"),
    endDate: new Date("August 31, 2024"),
    text: ["I'm currently working on this section. Come back later."],
  },
];

export default SubpagesData;
